/* Display estimates only. Shopify keeps cart, discounts and checkout in their native currency. */
const DAY = 86400000;
const CACHE_KEY = 'atiq:fx:egp:v1';
const ENDPOINT = 'https://open.er-api.com/v6/latest/EGP';
export function validUntil(data) {
  return Math.min(Number(data?.time_next_update_unix) * 1000, Number(data?.time_last_update_unix) * 1000 + DAY);
}
export function isFresh(data, now = Date.now()) {
  const last = Number(data?.time_last_update_unix) * 1000;
  return data?.result === 'success' && data.base_code === 'EGP' && data.rates?.EGP === 1 &&
    Number.isFinite(last) && last <= now + 300000 && last > now - DAY && validUntil(data) > now;
}
export function formatEstimate(amount, rate, currency, locale) {
  if (!Number.isFinite(Number(amount)) || !Number.isFinite(rate) || rate <= 0) throw new Error('Invalid amount or rate');
  return '≈ ' + new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'code' }).format(Number(amount) / 100 * rate);
}
export function parseNativeEGP(text) {
  const match = text.trim().match(/^(?:LE|EGP)\s*((?:[0-9]{1,3}(?:,[0-9]{3})+|[0-9]+)(?:\.[0-9]{2})?)(?:\s*(?:EGP|LE))?$/);
  return match ? Math.round(Number(match[1].replaceAll(',', '')) * 100) : null;
}
export const countryCurrencies = {"AC":"SHP","AD":"EUR","AE":"AED","AF":"AFN","AG":"XCD","AI":"XCD","AL":"ALL","AM":"AMD","AO":"AOA","AR":"ARS","AS":"USD","AT":"EUR","AU":"AUD","AW":"AWG","AX":"EUR","AZ":"AZN","BA":"BAM","BB":"BBD","BD":"BDT","BE":"EUR","BF":"XOF","BG":"EUR","BH":"BHD","BI":"BIF","BJ":"XOF","BL":"EUR","BM":"BMD","BN":"BND","BO":"BOB","BQ":"USD","BR":"BRL","BS":"BSD","BT":"BTN","BV":"NOK","BW":"BWP","BY":"BYN","BZ":"BZD","CA":"CAD","CC":"AUD","CD":"CDF","CF":"XAF","CG":"XAF","CH":"CHF","CI":"XOF","CK":"NZD","CL":"CLP","CM":"XAF","CN":"CNY","CO":"COP","CR":"CRC","CU":"CUP","CV":"CVE","CW":"XCG","CX":"AUD","CY":"EUR","CZ":"CZK","DE":"EUR","DG":"USD","DJ":"DJF","DK":"DKK","DM":"XCD","DO":"DOP","DZ":"DZD","EA":"EUR","EC":"USD","EE":"EUR","EG":"EGP","EH":"MAD","ER":"ERN","ES":"EUR","ET":"ETB","EU":"EUR","FI":"EUR","FJ":"FJD","FK":"FKP","FM":"USD","FO":"DKK","FR":"EUR","GA":"XAF","GB":"GBP","GD":"XCD","GE":"GEL","GF":"EUR","GG":"GBP","GH":"GHS","GI":"GIP","GL":"DKK","GM":"GMD","GN":"GNF","GP":"EUR","GQ":"XAF","GR":"EUR","GS":"GBP","GT":"GTQ","GU":"USD","GW":"XOF","GY":"GYD","HK":"HKD","HM":"AUD","HN":"HNL","HR":"EUR","HT":"USD","HU":"HUF","IC":"EUR","ID":"IDR","IE":"EUR","IL":"ILS","IM":"GBP","IN":"INR","IO":"USD","IQ":"IQD","IR":"IRR","IS":"ISK","IT":"EUR","JE":"GBP","JM":"JMD","JO":"JOD","JP":"JPY","KE":"KES","KG":"KGS","KH":"KHR","KI":"AUD","KM":"KMF","KN":"XCD","KP":"KPW","KR":"KRW","KW":"KWD","KY":"KYD","KZ":"KZT","LA":"LAK","LB":"LBP","LC":"XCD","LI":"CHF","LK":"LKR","LR":"LRD","LS":"LSL","LT":"EUR","LU":"EUR","LV":"EUR","LY":"LYD","MA":"MAD","MC":"EUR","MD":"MDL","ME":"EUR","MF":"EUR","MG":"MGA","MH":"USD","MK":"MKD","ML":"XOF","MM":"MMK","MN":"MNT","MO":"MOP","MP":"USD","MQ":"EUR","MR":"MRU","MS":"XCD","MT":"EUR","MU":"MUR","MV":"MVR","MW":"MWK","MX":"MXN","MY":"MYR","MZ":"MZN","NA":"NAD","NC":"XPF","NE":"XOF","NF":"AUD","NG":"NGN","NI":"NIO","NL":"EUR","NO":"NOK","NP":"NPR","NR":"AUD","NU":"NZD","NZ":"NZD","OM":"OMR","PA":"USD","PE":"PEN","PF":"XPF","PG":"PGK","PH":"PHP","PK":"PKR","PL":"PLN","PM":"EUR","PN":"NZD","PR":"USD","PS":"JOD","PT":"EUR","PW":"USD","PY":"PYG","QA":"QAR","RE":"EUR","RO":"RON","RS":"RSD","RU":"RUB","RW":"RWF","SA":"SAR","SB":"SBD","SC":"SCR","SD":"SDG","SE":"SEK","SG":"SGD","SH":"SHP","SI":"EUR","SJ":"NOK","SK":"EUR","SL":"SLE","SM":"EUR","SN":"XOF","SO":"SOS","SR":"SRD","SS":"SSP","ST":"STN","SV":"USD","SX":"XCG","SY":"SYP","SZ":"SZL","TA":"GBP","TC":"USD","TD":"XAF","TF":"EUR","TG":"XOF","TH":"THB","TJ":"TJS","TK":"NZD","TL":"USD","TM":"TMT","TN":"TND","TO":"TOP","TR":"TRY","TT":"TTD","TV":"AUD","TW":"TWD","TZ":"TZS","UA":"UAH","UG":"UGX","UM":"USD","US":"USD","UY":"UYU","UZ":"UZS","VA":"EUR","VC":"XCD","VE":"VES","VG":"USD","VI":"USD","VN":"VND","VU":"VUV","WF":"XPF","WS":"WST","XK":"EUR","YE":"YER","YT":"EUR","ZA":"ZAR","ZM":"ZMW","ZW":"ZWG"};

if (typeof document !== 'undefined') {
  const root = document.querySelector('atiq-market-controls');
  if (root) {
    const base = root.dataset.base;
    const locale = root.dataset.language || 'en';
    const target = countryCurrencies[root.dataset.country] || base;
    const originals = new WeakMap();
    let rates = null, pending = null, timer = null, retryAfter = 0;
    const currencyLabel = root.querySelector('[data-atiq-currency]');
    const status = root.querySelector('[data-atiq-rate-status]');
    const select = root.querySelector('select[name="country_code"]');
    const choice = root.querySelector('[data-atiq-choice]');
    const canEstimate = base === 'EGP' && target !== base;
    function message() {
      if (!canEstimate) return root.dataset.baseNote;
      if (!rates) return root.dataset.unavailable;
      const date = new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(rates.time_last_update_unix * 1000);
      return `${root.dataset.estimate} ${root.dataset.updated} ${date}`;
    }
    function localizeApp() {
      if (!locale.startsWith('ar')) return;
      const copy = {
        'Name Engraving':'نقش الاسم', 'Name in Arabic or English':'اكتب الاسم بالعربية أو الإنجليزية',
        'Name Location':'موضع الاسم', 'inside':'من الداخل', 'outside':'من الخارج', 'Hidden':'مخفي', 'Visible':'ظاهر',
        'Some products cannot be engraved from the outside It is automatically engraved from the inside':'بعض القطع لا يمكن نقشها من الخارج؛ يُنقش الاسم داخلها تلقائيًا.'
      };
      document.querySelectorAll('.gpo-element .label-content, .gpo-element .gpo-helptext, .gpo-element .gpo-ov-title span, .gpo-element .gpo-tooltip__title span, .gpo-element .gpo-counter, .gpo-element .gpo-selected-values').forEach(node => {
        const text = node.textContent.trim();
        const translation = copy[text] || (/^\d+\/\d+ characters$/.test(text) ? text.replace(' characters',' حرفًا') : null);
        if (translation && node.textContent !== translation) node.textContent = translation;
      });
    }
    function repairAppPrices() {
      if (!canEstimate) return;
      document.querySelectorAll('.price-list--product > sale-price, .price-list--product > compare-at-price').forEach(node => {
        if (node.querySelector('[data-atiq-money]')) return;
        const amount = parseNativeEGP(node.textContent);
        if (amount === null) return;
        const span = document.createElement('span');
        span.dataset.atiqMoney = String(amount);
        span.dataset.atiqBase = 'EGP';
        span.textContent = node.textContent;
        node.replaceChildren(span);
      });
    }
    function paint() {
      localizeApp();
      repairAppPrices();
      const active = canEstimate && isFresh(rates) && Number.isFinite(rates.rates[target]) && rates.rates[target] > 0;
      currencyLabel.textContent = active ? target : base;
      status.textContent = message();
      document.querySelectorAll('[data-atiq-credit]').forEach(node => { node.hidden = !active; });
      document.querySelectorAll('[data-atiq-currency-note]').forEach(node => { if (node.textContent !== message()) node.textContent = message(); });
      document.querySelectorAll('[data-atiq-money]').forEach(node => {
        const amount = node.dataset.atiqMoney;
        if (!originals.has(node)) originals.set(node, { amount, html: node.innerHTML });
        const record = originals.get(node);
        if (record.amount !== amount) { record.amount = amount; record.html = new Intl.NumberFormat(locale, { style:'currency', currency: node.dataset.atiqBase || base, currencyDisplay:'code' }).format(Number(amount)/100); }
        if (active && node.dataset.atiqBase === 'EGP') {
          const text = formatEstimate(amount, rates.rates[target], target, locale);
          if (node.textContent !== text) node.textContent = text;
        } else if (node.innerHTML !== record.html) node.innerHTML = record.html;
      });
    }
    function schedule() {
      clearTimeout(timer);
      if (canEstimate) timer = setTimeout(() => refresh(), rates ? Math.max(1000, validUntil(rates) - Date.now() + 1000) : 300000);
    }
    async function refresh() {
      if (!canEstimate) { paint(); return; }
      if (isFresh(rates)) { paint(); schedule(); return; }
      if (pending) return pending;
      if (Date.now() < retryAfter) { paint(); return; }
      rates = null;
      paint();
      status.textContent = root.dataset.loading;
      pending = (async () => {
        try {
          let cached;
          try { cached = JSON.parse(localStorage.getItem(CACHE_KEY)); } catch { /* Storage may be blocked. */ }
          if (isFresh(cached) && Number.isFinite(cached.rates[target]) && cached.rates[target] > 0) rates = cached;
          else {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 8000);
            let response;
            try { response = await fetch(ENDPOINT, { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-cache' }); } finally { clearTimeout(timeout); }
            if (!response.ok) throw new Error('Rate service unavailable');
            const payload = await response.json();
            if (!isFresh(payload) || !Number.isFinite(payload.rates[target]) || payload.rates[target] <= 0) throw new Error('Rate unavailable or expired');
            rates = payload;
            try { localStorage.setItem(CACHE_KEY, JSON.stringify(payload)); } catch { /* In-memory cache still works. */ }
          }
        } catch {
          rates = null;
          retryAfter = Date.now() + 300000;
        } finally { pending = null; paint(); schedule(); }
      })();
      return pending;
    }
    function showChoice() {
      const code = countryCurrencies[select.value] || base;
      let name = code;
      try { name = new Intl.DisplayNames([locale], { type:'currency' }).of(code); } catch { /* ISO code is sufficient. */ }
      choice.textContent = `${name} (${code})`;
    }
    root.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', () => { const returnTo = form.querySelector('input[name="return_to"]'); if (returnTo) returnTo.value = window.location.pathname + window.location.search; });
    });
    select.addEventListener('change', showChoice);
    showChoice();
    document.addEventListener('click', event => { const details=root.querySelector('details'); if (details.open && !details.contains(event.target)) details.open=false; });
    root.addEventListener('keydown', event => { if(event.key === 'Escape') { root.querySelector('details').open=false; root.querySelector('summary').focus(); } });
    let queued = false;
    const relevant = '[data-atiq-money], [data-atiq-currency-note], price-list, sale-price, compare-at-price, .gpo-element';
    new MutationObserver(records => {
      if (queued || !records.some(record => {
        const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return record.type === 'attributes' || element?.closest(relevant) || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(relevant) || node.querySelector(relevant)));
      })) return;
      queued = true;
      requestAnimationFrame(() => { queued=false; paint(); });
    }).observe(document.body, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['data-atiq-money'] });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
    window.addEventListener('online', () => { retryAfter=0; refresh(); });
    refresh();
  }
}
